import { FC } from 'react';
import { Box, CircularProgress, Typography, alpha } from '@mui/material';
import { useLoading } from '@carcareers/contexts';

export const Loading: FC = () => {
  const { loading, label } = useLoading();

  if (!loading) {
    return null;
  }

  return (
    <Box
      sx={(theme) => ({
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: alpha(theme.palette.grey[900], 0.8),
        backdropFilter: 'blur(4px)',
        padding: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 2,
        zIndex: 9999,
      })}
    >
      <CircularProgress size={32} sx={{ color: 'white' }} />
      <Typography variant="body1" sx={{ color: 'white' }}>
        {label}
      </Typography>
    </Box>
  );
};

export default Loading;
